import { ContactInput } from '@graphql/generated';
import { EventFormValues } from '../../presentational/hooks/useEventFormState';

export const formStateToContactInfo = (formState: EventFormValues, eventId: string): ContactInput => {
  const { contactValues } = formState;

  // Build address only if required fields are present
  const address =
    contactValues.address1 && contactValues.city && contactValues.region && contactValues.postalCode && contactValues.country && contactValues.countryCode
      ? {
          address1: contactValues.address1,
          address2: contactValues.address2 || null,
          city: contactValues.city,
          country: contactValues.country,
          countryCode: contactValues.countryCode,
          postalCode: contactValues.postalCode,
          region: contactValues.region,
          validated: false,
        }
      : null;

  // Build phone numbers array if phone number is present
  const phoneNumbers = contactValues.phoneNumber
    ? [
        {
          allowSMS: true,
          label: null,
          mobile: true,
          number: contactValues.phoneNumber,
        },
      ]
    : [];

  return {
    address,
    contact: {
      email: contactValues.email,
      eventId,
      firstName: contactValues.firstName,
      lastName: contactValues.lastName,
    },
    phoneNumbers,
  };
};
